define([],function() {
    return['encryptedBase64Key',function(decryptKey) {
        var _bilimits;
        var _prefilldata;
        return {
            setBiLimits: function (bilimit) {
                _bilimits = bilimit;
            },
            getBiLimits: function () {
                return _bilimits;
            },
            setPrefillData: function(prefilldata){
                _prefilldata = prefilldata ? prefilldata : null;
            },
            getPrefillData: function(){
                return _prefilldata ?  _prefilldata : null ;
            },
            decryptData(encryptedText) {
                if(!encryptedText){
                    return "";
                }
                const CryptoJS = require('crypto-js'); // importing the crypto js
                const encryptedBase64Key = decryptKey.value; // base64 conversion key
                const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
                const encryptedCipherText = encryptedText; // or encryptedData;
                const decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                // this is the decrypted data as a string
               return decryptedData.toString(CryptoJS.enc.Utf8);
            },
            encryptData(plaintText){
                if(!plaintText){
                    return "";
                }
                const CryptoJS = require('crypto-js'); // importing the crypto js
                const encryptedBase64Key = decryptKey.value; // base64 conversion key
                const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
                // this is Base64-encoded encrypted data
                const encryptedData = CryptoJS.AES.encrypt(plaintText, parsedBase64Key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
                });
                return encryptedData;
            }
        }
    }];
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/InMemorySession.js
 **/